module.exports = __webpack_public_path__ + "static/media/waterfront-slim.dfdba5df.jpg";